
 import image1 from "../../assets/image_1.png";
 import image2 from "../../assets/image_2.png";
 import image3 from "../../assets/image_3.png";
 import image4 from "../../assets/image_4.png";
 import image5 from "../../assets/homeownersample.jpg";
 import image6 from "../../assets/David.jpg";

// import Serviceprovidersicon from "../../assets/Service_Providers.png";
// import Homeownersicon from "../../assets/Homeowners.png";
// import ServiceRequesticon from "../../assets/Service_Request.png";
// import Settingicon from "../../assets/Settings.png";

 export const Homeownerlist=[
    {
       
        Username:"Claris",
        Mobilenumber:'+00 11 22 44 55 66',
        Lastname:'Johennasberg',
        status:'Submitted',
        email:'claris@gmail.com',
        icon:image1,
        Insidepic:image5
      
    },
    {
      
        Username:"David",
        Mobilenumber:'+00 11 22 44 55 66',
        Lastname:'Johennasberg',
        status:'On Hold',
        email:'david@gmail.com',
        icon:image2,
        Insidepic:image6
       
    },
   
    {
        
        Username:"Michal",
        Mobilenumber:'+00 11 22 44 55 66',
        Lastname:'Johennasberg',
        status:'Rejected',
        email:'michal@gmail.com',
        icon:image3,
        Insidepic:image5

      
    },
    {
        
        Username:"Claris",
        Mobilenumber:'+00 11 22 44 55 66',
        Lastname:'Johennasberg',
        status:'No Qualification',
        email:'claris@gmail.com',
        icon:image4,
        Insidepic:image5
    },
    {
        
        Username:"Karan",
        Mobilenumber:'+00 11 22 44 55 66',
        Lastname:'Johennasberg',
        status:'Rejected',
        email:'karan@gmail.com',
        icon:image4,
        Insidepic:image5
    },
    {
        
        Username:"Prem",
        Mobilenumber:'+00 11 22 44 55 66',
        Lastname:'Johennasberg',
        status:'Approved',
        email:'prem@gmail.com',
        icon:image4,
        Insidepic:image5
    },
    {
        
        Username:"Jack",
        Mobilenumber:'+00 11 22 44 55 66',
        Lastname:'Johennasberg',
        status:'Submitted',
        email:'jack@gmail.com',
        icon:image4,
        Insidepic:image5
    }
   
]